<template>
    <div class="[ mk-paginated-table ] pagination-card">
        <v-card>
            <!-- <v-card-title>
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    single-line
                    hide-details
                ></v-text-field>
            </v-card-title> -->

            <v-data-table
                :page="page"
                :pageCount="numberOfPages"
                :headers="headers"
                :items="items"
                :options.sync="options"
                :server-items-length="totalItems"
                :loading="loading"
                class="[ art-paginated-table ] elevation-1"
                :class="clickablerow ? 'row-pointer' : ''"
                @click:row="handleRowClick"
                hide-default-footer
                mobile-breakpoint="0"
            >
                <template v-for="header in headers.filter((header) => header.hasOwnProperty('formatter'))" v-slot:[`item.${header.value}`]="{ header, item }">
                    {{ formatValue(header, item) }}
                </template>

                <template v-slot:item.editUrl="{ item, header }">
                    <a
                        :href="header.url+item.id+'/edit'"
                        class="btn btn-success mb-3 mb-md-0 ml-md-3"
                        >Open</a
                    >
                </template>



                <template v-slot:item.artworkview="{ item, header }">
                    <div class="d-flex">
                        <div class="d-flex flex-column">
                            <div>
                                <img
                                    v-if="item.image_url"
                                    :src="item.image_url"
                                    width="100"
                                    height="100"
                                    class="mb-2 mr-4"
                                    style="border-radius: 8px;"
                                />
                            </div>

                            <!-- TODO: Add tracking for this, it's in the design 30-5-22 -->
                            <p
                                v-if="item.size"
                                class="color-200-placeholder mr-4 text-center"
                            >{{item.size}}</p>

                        </div>

                        <div>
                            <h3 class="mb-2" v-if="item.name">{{ item.name }}</h3>
                            <p v-if="item.artist">{{ item.artist.name }}</p>

                            <div class="mb-3" style="height: 1px; width: 48px; background-color: var(--color-border-grey);"></div>

                            <p class="mb-2" v-if="item.question">Question: <nl2br tag="span" :text="item.question" /></p>

                            <a
                                v-if="item.num_answers > 0"
                                @click="$parent.manageComment(item)"
                                href="javascript:void(0)"
                                class="color-primary fw-700"
                            >
                                Manage Comments ({{ item.num_answers }})
                            </a>
                            <p v-if="item.num_answers == 0" class="mb-0 color-200-placeholder">No comments</p>
                        </div>
                    </div>
                </template>

                <template v-slot:item.artistnameview="{ item, header }">
                    <div class="d-flex align-items-center">
                        <div>
                            <img
                                v-if="item.image_url"
                                :src="item.image_url"
                                class="rounded-circle mr-2"
                                width="32"
                                height="32"
                            />
                        </div>
                        <p class="mb-0 text-white">{{ item.name }}</p>
                    </div>
                </template>

                <template v-slot:item.actions="{ item, header }">
                    <v-icon v-if="header.qrlink"
                        dense
                        class="mr-2"
                        @click="$parent.qrLink(item)"
                    >
                        mdi-qrcode
                    </v-icon>
                    <v-icon v-if="header.download"
                        dense
                        class="mr-2"
                        @click="$parent.download(item)"
                    >
                        mdi-email-outline
                    </v-icon>
                    <v-icon
                        dense
                        class="mr-2"
                        @click="$parent.editItem(item)"
                    >
                        mdi-pencil-outline
                    </v-icon>
                    <v-icon
                        v-if="!header.hideRemove"
                        dense
                        @click="$parent.deleteItem(item)"
                    >
                        mdi-trash-can-outline
                    </v-icon>
                </template>

            </v-data-table>


            <div class="pgt-page-number-wrap">
                <v-pagination
                    v-model="page"
                    :length="numberOfPages"
                ></v-pagination>
            </div>


        </v-card>
    </div>
</template>

<style>
.row-pointer > .v-data-table__wrapper > table > tbody > tr:hover {
    cursor: pointer;
}


/* Only show first row on mobile */
/* This could cause issues for some tables */
@media only screen and (max-width: 800px) {
    .art-paginated-table .v-data-table__mobile-table-row .v-data-table__mobile-row:not(:first-child) {
        display: none;
    }

    .art-paginated-table .v-data-table__mobile-table-row .v-data-table__mobile-row p {
        word-break: break-word;
    }

    /* Hide the row table header */
    .art-paginated-table .v-data-table__mobile-table-row .v-data-table__mobile-row__header {
        display: none;
    }
}
</style>

<script>
export default {
    props: {
        headers: {
            type: Array,
        },
        clickablerow: {
            type: Boolean,
        },
    },
    data() {
        return {
            items: [],
            page: 1,
            totalItems: 0,
            numberOfPages: 0,
            options: {},
            search: "",
            awaitingSearch: false,
            loading: true
        };
    },
    watch: {
        options: {
            handler() {
                this.readDataFromAPI();
            },
        },
        search: function (val) {
            if (!this.awaitingSearch) {
                setTimeout(() => {
                    this.readDataFromAPI();
                    this.awaitingSearch = false;
                }, 1000); // 1 sec delay
            }
            this.awaitingSearch = true;
        },
        deep: true,
    },
    methods: {
        async readDataFromAPI() {
            const { page, itemsPerPage } = this.options;

            this.page = page;
            this.itemsPerPage = itemsPerPage;

            this.options.sortByText = '';
            this.options.sortByDesc = '';

            if(this.options.sortBy.length === 1) {
                this.options.sortByText = this.options.sortBy[0];
                this.options.sortByDesc = this.options.sortDesc[0];
            }

            try {
                this.items = [];
                this.loading = true;

                let modelDetails = await this.$parent.getModelDetails();
                modelDetails.page(this.page).limit(this.itemsPerPage);

                if (this.options.sortByText != "") {
                    modelDetails.orderBy((this.options.sortByDesc ? "-" : "") + this.options.sortByText);
                } else {
                    modelDetails.orderBy("-created_at");
                }

                if (this.search != "") {
                    modelDetails.where("search", this.search);
                }

                let modelData = await modelDetails.get();

                if (modelData.data !== undefined) {
                    this.items = modelData.data;
                    this.page = modelData.current_page;
                    this.numberOfPages = modelData.last_page;
                    this.itemsPerPage = modelData.per_page;
                    this.totalItems = modelData.total;
                }

                this.loading = false;
            } catch(err) {
                Vue.swal('', err.message, 'error');
            }
        },

        formatValue(header, item) {
            if(header.formatter == 'date') {
                return moment(item[header.value]).format(header.format);
            } else if(header.formatter == 'count') {
                return item[header.value].length;
            } else if(header.formatter == 'options') {
                let name = '';
                header.options.forEach((value, index) => {
                    if(value.id == item[header.value]) {
                        name = value.name;
                    }
                });

                return name;
            }else if(header.formatter == 'nl2br') {
                return item[header.value];
            }
        },

        handleRowClick(item) {
            if(this.clickablerow) {
                this.$parent.handleRowClick(item);
            }
        }
	},
};
</script>

<style></style>
